import api from '@utils/api';
import config from '@/config';

const vehicleTypeService = {
  // Get vehicle types list with pagination
  getVehicleTypes: async (params = {}) => {
    return api.get(config.endpoints.vehicleTypes.list, params);
  },

  // Get vehicle type by ID
  getVehicleTypeById: async (id) => {
    return api.get(`${config.endpoints.vehicleTypes.getById}/${id}`);
  },

  // Create new vehicle type
  createVehicleType: async (vehicleTypeData) => {
    return api.post(config.endpoints.vehicleTypes.create, vehicleTypeData);
  },

  // Update vehicle type
  updateVehicleType: async (vehicleTypeData) => {
    return api.put(`${config.endpoints.vehicleTypes.update}/${vehicleTypeData.id}`, vehicleTypeData);
  },

  // Delete vehicle type
  deleteVehicleType: async (id) => {
    return api.delete(`${config.endpoints.vehicleTypes.delete}/${id}`);
  },

  // Bulk delete vehicle types
  bulkDeleteVehicleTypes: async (ids) => {
    return api.delete(config.endpoints.vehicleTypes.delete, {
      params: { ids },
      paramsSerializer: {
        indexes: null,
      },
    });
  },
};

export default vehicleTypeService;
